module.exports = __webpack_public_path__ + "assets/img/h3_logo.dc1eebaa.png";